import { render, staticRenderFns } from "./testMange.vue?vue&type=template&id=99c78d7c&scoped=true&"
import script from "./testMange.vue?vue&type=script&lang=js&"
export * from "./testMange.vue?vue&type=script&lang=js&"
import style0 from "./testMange.vue?vue&type=style&index=0&lang=css&"
import style1 from "./testMange.vue?vue&type=style&index=1&id=99c78d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c78d7c",
  null
  
)

export default component.exports